import { FC, ReactElement } from 'react';

import { EvSpinner } from '@evinced-private/ui-common';

import { MobileIssueDetailsBlock } from 'src/common/components/mobile-issue-details-block/MobileIssueDetailsBlock';
import { MobileScreenshotBlock } from 'src/common/components/mobile-screenshot-block/MobileScreenshotBlock';
import { MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';

import './MobileComponentDetailsBlock.scss';

interface IComponentDetailsBlockProps {
	issue: MobileIssueDetails;
	runTime: string;
	scanName: string;
	isLoading: boolean;
	issueNumber: string;
	actionButtons?: ReactElement | null;
	isFullPageMode?: boolean;
}

export const MobileComponentDetailsBlock: FC<IComponentDetailsBlockProps> = ({
	issue,
	runTime,
	scanName,
	issueNumber,
	isLoading,
	actionButtons,
	isFullPageMode = false
}) => {
	const { screenshotDetails } = issue ?? {};

	if (isLoading) {
		return (
			<div className="spinner-wrapper">
				<EvSpinner />
			</div>
		);
	}

	return (
		<div className="mobile-component-details-block">
			<MobileScreenshotBlock
				screenshotDetails={screenshotDetails}
				scanName={scanName}
				runTime={runTime}
				issueNumber={issueNumber}
			/>
			<MobileIssueDetailsBlock
				issue={issue}
				issueNumber={issueNumber}
				actionButtons={actionButtons}
				headingLevel={isFullPageMode ? 1 : 3}
			/>
		</div>
	);
};
